export const TEMPLATE_DISPLAY_ORDER = [
  'blog-submitted-for-review-inform-admin',
  'blog-reviewed-rework-needed-inform-writer',
  'blog-published-inform-writer',
  'blog-published-inform-writer-followers',
  'registration-welcome-email',
  'resubscribe-promotional-mails-email-verification-otp',
  'mobile-number-used-linkedin-email-verification-otp',
  'share-bookmarks-annotations-from-another-account-email-verification-otp',
  'monthly-quota-reset',
  'subscription-purchased-confirmation',
  'subscription-renewal-reminder',
  'subscription-renewal-manual-action-needed-autorenew-off',
  'subscription-expired',
  'subscription-renewal-failed',
  'day-pass-expired-upsell-monthly-subscription',
  'subscription-renewal-success',
  'payment-receipt-email-admin-usage',
  'invoice-email-admin-usage',
  'product-updates-newsletter',
  'general-activity-notification',
  'security-login-alert',
  'system-automated-notification',
]

const TEMPLATE_ORDER_INDEX = TEMPLATE_DISPLAY_ORDER.reduce((acc, name, index) => {
  acc[name] = index
  return acc
}, {})

const normalizeTemplateName = (name) =>
  String(name || '')
    .trim()
    .toLowerCase()

export const sortTemplatesByDisplayOrder = (templates = []) =>
  [...templates].sort((a, b) => {
    const nameA = normalizeTemplateName(a?.name)
    const nameB = normalizeTemplateName(b?.name)

    const hasOrderA = Object.prototype.hasOwnProperty.call(
      TEMPLATE_ORDER_INDEX,
      nameA,
    )
    const hasOrderB = Object.prototype.hasOwnProperty.call(
      TEMPLATE_ORDER_INDEX,
      nameB,
    )
    const indexA = hasOrderA ? TEMPLATE_ORDER_INDEX[nameA] : Number.MAX_SAFE_INTEGER
    const indexB = hasOrderB ? TEMPLATE_ORDER_INDEX[nameB] : Number.MAX_SAFE_INTEGER

    if (indexA !== indexB) {
      return indexA - indexB
    }

    return nameA.localeCompare(nameB)
  })
